import * as React from "react"
export const Svg_021 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={59}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M0 55.16h58V25.925H0V55.16ZM44.293 31.9h3.398v3.457h-3.398V31.9Zm0 6.914h3.398v3.457h-3.398v-3.457Zm0 6.914h3.398v3.457h-3.398v-3.457ZM37.496 31.9h3.398v3.457h-3.398V31.9Zm0 6.914h3.398v3.457h-3.398v-3.457Zm0 6.914h3.398v3.457h-3.398v-3.457ZM30.7 31.9h3.399v3.457h-3.399V31.9Zm0 6.914h3.399v3.457h-3.399v-3.457Zm0 6.914h3.399v3.457h-3.399v-3.457ZM23.902 31.9h3.399v3.457h-3.399V31.9Zm0 6.914h3.399v3.457h-3.399v-3.457Zm0 6.914h3.399v3.457h-3.399v-3.457ZM17.105 31.9h3.399v3.457h-3.399V31.9Zm0 6.914h3.399v3.457h-3.399v-3.457Zm0 6.914h3.399v3.457h-3.399v-3.457ZM10.31 31.9h3.398v3.457h-3.398V31.9Zm0 6.914h3.398v3.457h-3.398v-3.457Zm3.398 6.914v3.457h-3.398v-3.457h3.398Z"
    />
    <path fill="url(#b)" d="M10.309 3.84h3.398v5.28h-3.398V3.84Z" />
    <path
      fill="url(#c)"
      d="M58 9.216H47.691V14.4h-3.398V9.216H13.707V14.4h-3.398V9.216H0v13.252h58V9.216Zm-19.429 8.412H19.429V14.17h19.142v3.457Z"
    />
    <path fill="url(#d)" d="M44.293 3.84h3.398v5.28h-3.398V3.84Z" />
    <defs>
      <linearGradient
        id="a"
        x1={13.412}
        x2={22.229}
        y1={30.31}
        y2={58.619}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={11.095}
        x2={13.897}
        y1={4.632}
        y2={7.551}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={13.412}
        x2={15.361}
        y1={11.204}
        y2={25.005}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={45.079}
        x2={47.881}
        y1={4.632}
        y2={7.551}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)